import { Component, OnInit } from '@angular/core';
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import {DialogModel} from "@shared/models/dialog.model";
import {FormBuilder} from "@angular/forms";
import {Dac6ReporterApiService} from "../../../services/dac6-reporter.service";

@Component({
    standalone: false,
    selector: 'particle-arrangement-chart-children-drop-down-dialog',
  templateUrl: './arrangement-chart-children-drop-down-dialog.component.html',
  styleUrls: ['./arrangement-chart-children-drop-down-dialog.component.scss']
})
export class ArrangementChartChildrenDropDownDialogComponent implements OnInit, IDialogView {
  entities: any[];
  data: DialogModel;
  selectedEntityId: string;

  constructor(private formBuilder: FormBuilder,
              private dac6ReporterApiService: Dac6ReporterApiService) { }

  ngOnInit() {
    this.dac6ReporterApiService.getAllArrangementChartEntities().subscribe((response: any[])=>{
      if(response){
        this.entities = response;
        const parentEntity = response.find(o=>o.isParent === true);
        if(parentEntity){
          this.selectedEntityId = parentEntity.id;
        }
        /*if(parentEntity){
          this.recordForm.patchValue({
            selectedEntity: parentEntity.id
          });
        }else{
          this.recordForm.patchValue({
            selectedEntity: response[0].id
          });
        }*/
      }
    })
  }
  onOkClicked(): boolean {
    this.data.input['selectedEntity'] = this.selectedEntityId;
    return true;
  }
  onSelect(event){
    console.log(event);
    this.selectedEntityId = event.value;
  }
}
